import { Component, Input, OnInit, OnChanges } from "@angular/core";
import { displayBigNumber } from "../../ng-util/tools";
import * as lodash from "lodash";

export interface INgBarGraphValue {
    label: string;
    value: number;
    unit: string;
    bgColor: string;
    txtColor?: string;
}

@Component({
    selector: "ng-bar-graph",
    templateUrl: "./ng-bar-graph.component.html",
    styleUrls: ["./ng-bar-graph.component.css"]
})
export class NgBarGraphComponent implements OnInit, OnChanges {
    @Input() input: INgBarGraphValue[];
    @Input() inlineLabels: boolean;
    @Input() showTooltip: boolean;
    @Input() formatBigNumber: boolean;

    isValid: boolean;

    unit: string;
    bgColor: string;
    bgValueColor: string;

    perc: number[] = [];

    // Store pretty values
    formValues: string[] = [];

    ngOnInit() {
        this.init();
    }

    ngOnChanges() {
        this.init();
    }

    private init() {
        this.isValid = true;
        delete this.unit;

        const setInvalid = (msg: string) => this.isValid = false;

        if (!this.input || this.input.length !== 2) {
            setInvalid("The values array lenght must be exactly 2");
            return;
        }

        this.input.forEach(v => {
            if (!this.unit) {
                this.unit = v.unit;
            } else if (this.unit !== v.unit) {
                setInvalid("All values units must be the same");
                return;
            }
        });

        const sum = lodash.sumBy(this.input, "value");
        this.perc = this.input.map(i => (i.value / sum) * 100);

        this.formValues = this.input.map(d => displayBigNumber(d.value));
    }
}
